<template>
  <div class="survey">
    <div class="pager">Question {{ currentQuestionIndex + 1 }} sur {{ questions.length }}</div>

    <h2 class="question">
      {{ currentQuestion.statement }}
    </h2>

    <ProgressBar :value="currentQuestionIndex" :max="questions.length" />

    <SurveyAnswerList :answers="currentQuestion.answers" @selectAnswer="handleSelectAnswer" />

    <div class="actions">
      <button :disabled="previousQuestionIndex === null" type="button" class="btn" @click.prevent="previousQuestion">
        Précédent
      </button>
      <button
        :disabled="nextQuestionIndex === null || !questionAnswered"
        type="button"
        class="btn btn-success"
        @click.prevent="nextQuestion"
      >
        Suivant
      </button>
    </div>
  </div>
</template>

<script>
import find from 'lodash/find'
import clone from 'lodash/clone'
import some from 'lodash/some'

import ProgressBar from './ProgressBar.vue'
import SurveyAnswerList from './SurveyAnswerList.vue'

export default {
  name: 'Survey',
  components: {
    ProgressBar,
    SurveyAnswerList
  },
  props: {
    survey: {
      type: Object,
      required: true
    }
  },
  data() {
    const questions = this.survey.questions.map(question => {
      return Object.assign(question, {
        answers: question.answers.map(answer => {
          return Object.assign(answer, { selected: false })
        })
      })
    })

    return {
      questions,
      currentQuestionIndex: 0,
      allQuestionsAnswered: false
    }
  },
  computed: {
    currentQuestion() {
      return this.questions[this.currentQuestionIndex]
    },
    nextQuestionIndex() {
      const nextIndex = this.currentQuestionIndex + 1
      return nextIndex >= this.questions.length ? null : nextIndex
    },
    previousQuestionIndex() {
      const previousIndex = this.currentQuestionIndex - 1
      return previousIndex < 0 ? null : previousIndex
    },
    questionAnswered() {
      return some(this.currentQuestion.answers, ['selected', true])
    },
    responses() {
      return this.questions.map(question => {
        return {
          question: question.statement,
          answer: clone(find(question.answers, ['selected', true]))
        }
      })
    }
  },
  methods: {
    handleSelectAnswer(answerId) {
      this.questions[this.currentQuestionIndex].answers = this.questions[this.currentQuestionIndex].answers.map(answer => {
        return Object.assign(answer, { selected: answer.id === answerId })
      })

      this.nextQuestion()
    },
    nextQuestion() {
      if (this.nextQuestionIndex === null) {
        this.allQuestionsAnswered = true
      } else {
        this.currentQuestionIndex = this.nextQuestionIndex
      }

      if (!this.allQuestionsAnswered) return
      this.$emit('done', this.responses)
    },
    previousQuestion() {
      if (this.previousQuestionIndex === null) return
      this.currentQuestionIndex = this.previousQuestionIndex
    }
  }
}
</script>

<style scoped>
.survey {
  overflow: hidden;
}

.pager {
  color: rgba(0, 0, 0, 0.38);
  font-size: 0.688rem;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0 0 1rem;
}

.question {
  color: rgba(0, 0, 0, 0.87);
  font-size: 1.125rem;
  font-weight: 500;
  margin: 0 0 1rem;
}

.actions {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 2rem;
}

button:first-child:before {
  display: inline-block;
  content: '\2039';
  padding: 0 0.375rem 0 0;
}

button:last-child:after {
  display: inline-block;
  content: '\203A';
  padding: 0 0 0 0.375rem;
}
</style>
